import { gql } from 'graphql-request';

export const alertQuery = gql`
  query {
    alertCollection(where: { internalName: "Simo-shop-is-closed" }, limit: 1) {
      items {
        showAlert
        fullPageRedirect
        content {
          json
        }
        type
      }
    }
  }
`;

export const softErroModalQuery = gql`
  query {
    simoSoftErrorModalCollection(where: { id: 404 }, limit: 1) {
      items {
        title
        content {
          json
        }
      }
    }
  }
`;

export const simoFrontPageQuery = gql`
  fragment resourceShortTextFragment on ResourcesShortText {
    key
    textValue: value
  }

  fragment resourceImageFragment on ResourcesImage {
    key
    imageValue: value {
      url
    }
  }
  fragment campaignFragment on Campaign {
    productCode
    productName
    promotionVisibility
    promotionText
  }

  fragment callToActionButton on Button {
    label
    url
  }

  fragment spotboxFragment on SpotBox {
    header
    subtitle
    componentName
    description {
      json
    }
    legalText {
      json
    }
    spotBoxMedia {
      url
    }
    imageAlignment
    callToActionButton {
      ...callToActionButton
    }
  }
  query {
    hero: resourceSetCollection(where: { resourceSetName: "simo-frontpage-hero" }, limit: 1) {
      items {
        resourcesCollection {
          items {
            ...resourceShortTextFragment
            ...resourceImageFragment
          }
        }
      }
    }
    spotBoxContainer: sectionContainerCollection(
      where: { componentName: "Spotbox-simo-frontpage-container" }
      limit: 1
    ) {
      items {
        header
        componentsCollection {
          items {
            ...spotboxFragment
          }
        }
      }
    }
    subscriptionCard: resourceSetCollection(
      where: { resourceSetName: "simo-subscriptions" }
      limit: 1
    ) {
      items {
        resourcesCollection {
          items {
            ...resourceShortTextFragment
          }
        }
      }
    }
    campaigns: campaignSetCollection(limit: 1) {
      items {
        productCodeCollection {
          items {
            ...campaignFragment
          }
        }
      }
    }
    faq: faqListCollection(where: { componentName: "simo-frontpage-FAQ" }, limit: 1) {
      items {
        header
        listItemsCollection {
          items {
            question
            answer {
              json
            }
          }
        }
        faqArrowIcon {
          ...resourceImageFragment
        }
        buttonTextOpened
        buttonTextClosed
      }
    }
    loginmodule: loginmoduleCollection(where: { internalName: "Simo-login-frontpage" }, limit: 1) {
      items {
        loginbutton {
          label
          url
        }
        deliveryicon {
          url
        }
        deliverytext {
          json
        }
        logintext {
          json
        }
      }
    }
    mobilmarked: resourceCollection(where: { key: "mv-top-nav-mobilmarked" }) {
      items {
        valueBoolean
      }
    }
    metaTags: simoLandingPageCollection(limit: 1) {
      items {
        metaTagHelmetDescription
        metaTagHelmetTitle
      }
    }
  }
`;

export const simoSingleSubscriptionQuery = gql`
  fragment resourceShortTextFragment on ResourcesShortText {
    key
    textValue: value
  }
  fragment resourceLongTextFragment on ResourcesLongText {
    key
    value {
      json
    }
  }
  fragment resourceImageFragment on ResourcesImage {
    key
    imageValue: value {
      url
    }
  }

  fragment callToActionButton on Button {
    label
    url
  }

  fragment spotboxFragment on SpotBox {
    header
    subtitle
    componentName
    description {
      json
    }
    legalText {
      json
    }
    spotBoxMedia {
      url
    }
    imageAlignment
    callToActionButton {
      ...callToActionButton
    }
  }
  query {
    subscriptionCollection: productSimOnlySingleSubscriptionCollection(limit: 15) {
      items {
        name
        productCode
        hero {
          name
          description
          descriptionRichText {
            json
          }
          campaignText
          backgroundImage {
            url
          }
        }
        faq {
          header
          buttonTextOpened
          buttonTextClosed
          faqArrowIcon {
            ...resourceImageFragment
          }
          listItemsCollection {
            items {
              question
              answer {
                json
              }
            }
          }
        }

        loginmodule {
          loginbutton {
            label
            url
          }
          deliveryicon {
            url
          }
          deliverytext {
            json
          }
          logintext {
            json
          }
        }

        subscriptionSlider {
          heading {
            title
            bodyText {
              json
            }
          }
          buttonText
          message {
            json
          }
          modalMaxNoOfAllowedSubscriptionsTitle
          modalMaxNoOfAllowedSubscriptionSubtitle
          modalWrongCombinationOfSubscriptionsTitle
          modalButtonOk
          modalWrongCombinationOfSubscriptionsSubtitle
          modalButtonCancel
          modalButtonGoToBasket
        }
        spotboxSection {
          header
          componentsCollection {
            items {
              ...spotboxFragment
            }
          }
        }
        usp {
          key
          pairListCollection {
            items {
              key
              text {
                json
              }
              image {
                url
              }
            }
          }
          legalText {
            leftColoumn {
              json
            }
            rightColoumn {
              json
            }
          }
        }
        minimumPriceCalculation {
          heading {
            title
            bodyText {
              json
            }
          }
          sectionTitleCollection {
            items {
              ...resourceShortTextFragment
              ...resourceLongTextFragment
            }
          }
        }
      }
    }
  }
`;

export const simoBasket = gql`
  fragment resourceShortTextFragment on ResourcesShortText {
    key
    textValue: value
  }
  fragment resourceLongTextFragment on ResourcesLongText {
    key
    value {
      json
    }
  }
  query {
    basket: simoBasketCollection(limit: 10) {
      items {
        title
        header {
          json
        }
        buttonContinue
        modalHeaderMainSubs
        modalHeaderExtraSubs
        modalSubtitleMainSubs
        modalButtonCancel
        modalButtonDelete
        emptyBasketTitle
        emptyBasketSubtitle
        emptyBasketButton
        buttonFrontPage
        minimumBindingText {
          json
        }
        minimumPriceCalculation {
          heading {
            title
            bodyText {
              json
            }
          }
          sectionTitleCollection {
            items {
              ...resourceShortTextFragment
              ...resourceLongTextFragment
            }
          }
        }
      }
    }
  }
`;

export const configurationOverviewPage = gql`
  fragment resourceImageFragment on ResourcesImage {
    key
    imageValue: value {
      url
    }
  }
  query {
    simoConfigurationCollection(where: { internalName: "Configuration overview" }, limit: 1) {
      items {
        header
        headerSingular
        subtitle {
          json
        }
        subtitleSingular {
          json
        }
      }
    }
    faqPortNumber: faqListCollection(
      where: { componentName: "SimoConfigurationPortNumberFaq" }
      limit: 1
    ) {
      items {
        header
        buttonTextOpened
        buttonTextClosed
        faqArrowIcon {
          ...resourceImageFragment
        }
        listItemsCollection {
          items {
            question
            answer {
              json
            }
          }
        }
      }
    }
    loginmodule: loginmoduleCollection(
      where: { internalName: "Simo-login-configuration" }
      limit: 1
    ) {
      items {
        loginbutton {
          label
          url
        }
        deliveryicon {
          url
        }
        deliverytext {
          json
        }
        logintext {
          json
        }
      }
    }
    faqSaldomax: faqListCollection(
      where: { componentName: "SimoConfigurationSaldomaxFaq" }
      limit: 1
    ) {
      items {
        header
        buttonTextOpened
        buttonTextClosed
        faqArrowIcon {
          ...resourceImageFragment
        }
        listItemsCollection {
          items {
            question
            answer {
              json
            }
          }
        }
      }
    }
  }
`;

export const checkout = gql`
  query {
    loginmodule: loginmoduleCollection(where: { internalName: "Simo-login-checkout" }, limit: 1) {
      items {
        loginbutton {
          label
          url
        }
        deliveryicon {
          url
        }
        deliverytext {
          json
        }
        logintext {
          json
        }
      }
    }

    simoCheckoutCollection(limit: 1) {
      items {
        overviewCheckboxTermsHeader
        overviewCheckboxOptionalHeader
        overviewCheckboxTerms {
          json
        }
        overviewExistingSubscriptions {
          json
        }
        overviewCheckboxOptional {
          json
        }
        deliveryText {
          json
        }
        contactEmailHeader
        contactEmailText {
          json
        }
        contactLegalText {
          json
        }
        contactTelephoneNumberHeader
        contactTelephoneNumberText {
          json
        }
        paymentDescription {
          json
        }
      }
    }
  }
`;

/* subscriptionCardNewCategory: categoryListCollection(limit: 20) {
      items {
        componentName
        categoriesCollection {
          items {
            subcategory1 {
              json
            }
            subcategory2 {
              json
            }
            category {
              json
            }
            name
          }
        }
      }
    } */
